import { Injectable } from '@angular/core';
import { FeatureFlags } from '@rd/types/feature-flag.type';
import { EnvService } from '../env/env.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  constructor(private envService: EnvService) {}

  public isProduction = this.envService.isProduction;

  // Disable all ANZ R3 feature flags for other WLs to avoid unwanted changes
  // Since FeatureFlagService is now providedIn: 'root'
  // All Wls will have this service so we will make all flags to be false by default
  // to prevent unwanted feature on WL that doesn't have them
  protected featureFlags: Record<FeatureFlags, boolean> = {
    apid: false,
    autoRedemption: false,
    shoppingCart: false,
    merchandise: false,
    tcListing: false,
    cashbackToBankAccount: false,
    multiPointsBalance: false,
    poolPoints: false,
  };

  get isAutoRedemptionEnabled(): boolean {
    return !!this.featureFlags[FeatureFlags.AutoRedemption];
  }

  isEnable(featureFlag: FeatureFlags): boolean {
    return this.featureFlags[featureFlag];
  }
}
